import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { ServerSettingsInstance } from '~src/settings/services/ServerSettings';
import { SiteAuthenticationSettingsService } from '~src/settings/siteAuthSettings/services/SiteAuthenticationSettingsService';
import { ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';
import { EditSiteSettings, showEditSiteDialog } from '~src/ts/siteManagement/services/EditSiteAction';

import { Messages } from '../../../codegen/Localize';
import { ISiteSettingsForServerAdmin } from '../../../settings/types/ISite';
import { Set } from '../../../ts/models/Set';
import { ActivateSitesAction } from '../../../ts/siteManagement/services/ActivateSitesAction';
import { DeleteSitesAction } from '../../../ts/siteManagement/services/DeleteSitesAction';
import { Sites } from '../../../ts/siteManagement/services/resources/Sites';
import { SuspendSitesAction } from '../../../ts/siteManagement/services/SuspendSitesAction';
import { SiteActivate, SiteDelete, SiteEdit, SiteSuspend } from '../../actions/AppActionTypes';
import { requestFailed } from '../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { SiteMenuAction } from '../../actions/spaces/SiteMenuActions';

export function* handleSuspend(action: SiteMenuAction): SagaIterator {
  try {
    yield call(suspendSite, action.items);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function suspendSite(sites: ISiteSettingsForServerAdmin[]) {
  return SuspendSitesAction.showSuspendSitesActionDialog(Set.fromIdItemArray(sites));
}

export function* handleActivate(action: SiteMenuAction): SagaIterator {
  try {
    yield call(activateSite, action.items);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function activateSite(sites: ISiteSettingsForServerAdmin[]) {
  return ActivateSitesAction.showActivateSitesActionDialog(Set.fromIdItemArray(sites));
}

export function* handleEdit(action: SiteMenuAction): SagaIterator {
  try {
    yield call(editSiteReact, action.items);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

 export async function editSiteReact(sites: ISiteSettingsForServerAdmin[]) {
  const serverSettings = getSessionManagementServiceInstance().isSessionServerAdmin()? await ServerSettingsInstance.fetch(): null;
  const siteAuthSettings = await SiteAuthenticationSettingsService.getSiteAuthenticationSettings(/* refresh */ true);
  const siteSettingsForServerAdmin = await Sites.instance.getSiteSettingsForServerAdminById(sites[0].id);
  const siteSettings: ISiteSettingsForSiteAdmin = {
    siteAdminSettings: siteSettingsForServerAdmin.siteAdminSettings,
    siteId: sites[0].id,
    subscriptionSettings: siteSettingsForServerAdmin.subscriptionSettings
  };
  const settings: EditSiteSettings = {
    serverSettings: serverSettings,
    siteSettings: siteSettings,
    siteSettingsForServerAdmin: siteSettingsForServerAdmin,
    siteAuthenticationSettings: siteAuthSettings
  };
  return showEditSiteDialog(settings);
}


export function* handleDelete(action: SiteMenuAction): SagaIterator {
  try {
    yield call(deleteSite, action.items);

    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function deleteSite(sites: ISiteSettingsForServerAdmin[]) {
  return DeleteSitesAction.execute(Set.fromIdItemArray(sites));
}

export function* rootSiteMenuActionSaga(): SagaIterator {
  yield takeEvery(SiteSuspend, handleSuspend);
  yield takeEvery(SiteActivate, handleActivate);
  yield takeEvery(SiteEdit, handleEdit);
  yield takeEvery(SiteDelete, handleDelete);
}
